export default __webpack_public_path__ + "static/media/rapidstore-logo.8d372826.png";